import { Module } from "@/services/module";
import { LoginFromTypes } from "@/utils/router_helper/types";

// 存储触发登录的位置，在登录过程完成之后执行后续流程
export class LoginFromModule extends Module {
  constructor() {
    super(null);
  }
  setPlace(place: LoginFromTypes | undefined | null) {
    this.set(place ? place : null);
  }
  getPlace(): LoginFromTypes | null {
    return this.get();
  }
}

export default new LoginFromModule();
